module.exports = __webpack_public_path__ + "static/media/savio.73437415.png";